import format from 'date-fns/format'

const toApiDateTime = (date: Date) => format(date, "yyyy-MM-dd'T'HH:mm:ss")

export default toApiDateTime
